import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Je suis débutant(e), les guides sont-ils adaptés ?",
    a: "Oui, entièrement. Tout est expliqué pas à pas, sans prérequis : le plan démarre en douceur puis monte en rythme progressivement. Tu n'as besoin d'aucune méthode préalable.",
  },
  {
    q: "Sous quel format vais-je recevoir mon guide ?",
    a: "Un PDF numérique, téléchargeable immédiatement après ton achat depuis ton espace membre. Lisible sur téléphone, tablette et ordinateur — et imprimable si tu préfères le papier.",
  },
  {
    q: "Combien de temps par jour faut-il prévoir ?",
    a: "Vingt à trente minutes par jour suffisent. Le programme est conçu pour les emplois du temps chargés : la régularité compte plus que la quantité.",
  },
  {
    q: "Comment ça se passe après mon paiement ?",
    a: "Tu reçois immédiatement un email avec ton code d'activation personnel. Crée ton compte, entre le code dans ton espace membre, et tes guides se débloquent pour un téléchargement instantané — avec un accès à vie.",
  },
  {
    q: "Et si je n'arrive pas à suivre le rythme ?",
    a: "Aucun problème : le plan est flexible, chaque semaine peut être refaite sans culpabilité. L'objectif est la constance, pas la perfection. Ton accès est à vie, tu avances à ton rythme.",
  },
  {
    q: "Puis-je être remboursé(e) ?",
    a: "Toutes les conditions sont détaillées dans notre politique de remboursement, accessible en bas de page. Une question avant d'acheter ? Écris-nous via le formulaire de contact, on te répond rapidement.",
  },
];

const EASE = [0.16, 1, 0.3, 1];

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="faq" data-testid="faq-section">
      <div className="container">
        <motion.div
          className="section-head"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
        >
          <div className="eyebrow">Questions fréquentes</div>
          <h2>Tout ce que tu te demandes avant de commencer</h2>
          <p>Et si ta question n'y est pas, écris-nous via le formulaire de contact en bas de page.</p>
        </motion.div>

        <motion.div
          className="faq-wrap"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease: EASE }}
        >
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className={`faq-item ${isOpen ? "open" : ""}`} data-testid={`faq-item-${i}`}>
                <button
                  className="faq-q"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  data-testid={`faq-question-${i}`}
                >
                  <span>{f.q}</span>
                  <ChevronDown size={20} />
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      className="faq-a"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.45, ease: EASE }}
                    >
                      <p className="faq-a-inner" data-testid={`faq-answer-${i}`}>{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
